/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

/**
 * Add data-parsley-validate-if-empty="true" and data-parsley-required-when-visible to the template tag to trigger this validator 
 */

window.Parsley.addValidator("requiredWhenVisible", {
  validateString(value, requirement, instance) {
    if (requirement) {
      if (instance.$element.is(':visible')) {
        return !!value;
      } 
      return true;
    }
    return true;
  },
  messages: {
    en: 'This value is required.',
  },
  priority: 33
})